import { AxiosResponse } from 'axios'
import { http } from '@api/RequestApi'

import { IClosure, IClosurePayload } from '@store/features/closure/closure.types'
import { BaseAPI } from './ApiServices'

class ClosureService extends BaseAPI {
  private prefix = '/closures'

  public async getClosures(courseId: string) {
    BaseAPI.isUserExist()

    const response = await http.get<any, AxiosResponse<{ data: IClosure[] }>>(
      `${this.prefix}?courseId=${courseId}`
    )

    return response?.data
  }

  public async createClosure(data: IClosurePayload) {
    return http.post<IClosurePayload, AxiosResponse<string>>(`${this.prefix}`, data)
  }

  public async delete(id: string) {
    return http.delete<void, AxiosResponse<string>>(`${this.prefix}/${id}`)
  }

  public async update(data: IClosurePayload) {
    return http.put<IClosurePayload, AxiosResponse<string>>(`${this.prefix}/${data.id}`, data)
  }
}

export default ClosureService
